{
  "title": "Registrations That Need an Update, and Reminder Emails",
  "description": "See the students who completed registration but whose answers no longer fit the current form, and send a reminder after previewing and testing.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the students who need to update have received a reminder, and they drop off the list automatically once they save.",
  "roleNote": "Organizer",
  "prerequisites": [
    "Team-management permission (anyone can see the list; the send buttons need it)",
    "A contact email is filled in on the competition settings"
  ],
  "pathLabel": "Competition management → Data → Registration data",
  "steps": [
    {
      "title": "1. View the list",
      "description": "At the top of the Registration data page, \"Registrations that need an update\" lists students who completed registration but whose saved answers no longer fit the current published form: name, team and the fields still missing, without email or answers. The whole section is hidden when nobody needs to update. A new required field after a form revision, or an unticked required checkbox, puts a student here."
    },
    {
      "title": "2. Send a test email to yourself",
      "description": "Press \"Send a test email to me\"; it goes only to your own inbox, marked as a test, so you can check the content and the organizer contact email in the footer."
    },
    {
      "title": "3. Preview and send the reminder",
      "description": "Press \"Send update reminder\"; a dialog first shows the recipient count and a preview of the exact subject and body. Cancel sends nothing; confirming sends to each student personally, not to teammates or teachers."
    }
  ],
  "afterward": [
    "Once a student updates and saves, they drop off the list automatically",
    "The send result is recorded in the audit log with success and failure counts, without email addresses",
    "This page never fills in or edits a student's registration, and does not change their progress"
  ],
  "nextSteps": "If you need to notify people beyond students who need to update, see \"How to Publish an Announcement and Email It\".",
  "faq": [
    {
      "q": "I don't see the \"Registrations that need an update\" section?",
      "a": "It is hidden when nobody needs to update; also the test and reminder buttons are visible only with team-management permission."
    },
    {
      "q": "Can I send the reminder more than once?",
      "a": "Yes, but each send goes to everyone still on the list, so check the count and preview first."
    },
    {
      "q": "What do students see?",
      "a": "The registration card on the competition page, their My Competitions card and Home all show \"Needs update\" until they update."
    }
  ]
}
